var map = {
	"./DataScience/years.json": 18887,
	"./ai/years.json": 63948,
	"./android/years.json": 93652,
	"./arvr/years.json": 25878,
	"./backend/years.json": 39479,
	"./bioinformatics/years.json": 64265,
	"./biotech/years.json": 26895,
	"./blockchain/years.json": 13656,
	"./creativedesign/years.json": 73438,
	"./cybersecurity/years.json": 48594,
	"./database/years.json": 67609,
	"./devops/years.json": 15335,
	"./edgecomputing/years.json": 25021,
	"./embedded-system/years.json": 6219,
	"./foss/years.json": 35825,
	"./frontend/years.json": 9196,
	"./generative-ai/years.json": 9758,
	"./ios/years.json": 42666,
	"./iot/years.json": 17023,
	"./marketing/years.json": 90674,
	"./photonics/years.json": 43637,
	"./pm/years.json": 89257,
	"./qa/years.json": 64742,
	"./quantum-computing/years.json": 51523,
	"./robotics-automation/years.json": 37970,
	"./space-technology/years.json": 45100,
	"./uiux/years.json": 62980,
	"./web/years.json": 4237
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(() => {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 50187;
module.exports = webpackAsyncContext;